import {call, put, takeLatest} from 'redux-saga/effects';

import {operations} from './operations';
import {actions} from './modules';

function* watchEnabledDoctorsActions() {
    yield takeLatest(actions.getEnabledDoctors, getEnabledDoctors);
}

function* getEnabledDoctors({ payload }) {
    try {
        const response = yield call(operations.getEnabledDoctors, payload);

        if (response.data.items.length === 0) {
            yield put(actions.getEnabledDoctorsFail('service is not supported in your state'));
        } else {
            yield put(actions.getEnabledDoctorsSuccess(response.data.items));
        }

    } catch (error) {
        const response = {
            data: error.response.data,
            status: error.response.status,
            statusText: error.response.statusText,
        };
        yield put(actions.getEnabledDoctorsFail(response));
    }
}

export const sagas = watchEnabledDoctorsActions;